import React from "react";
import SubjectPageSectoin from "../../Sections/SubjectPageSection/Content";
const SubjectPage = () => {
  return <SubjectPageSectoin />;
};

export default SubjectPage;
